module.exports = __webpack_public_path__ + "images/how-it-works-header.8899a1dc7296b9693f22e047bca0fe9f.jpg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/how-it-works-header.jpg
// module id = 1006
// module chunks = 0